export default {
  "content": "<title>Mic</title><path d=\"M192 448h128m64-240v32c0 70.4-57.6 128-128 128s-128-57.6-128-128v-32m128 160v80\" class=\"ionicon-fill-none ionicon-stroke-width\"/><path d=\"M256 320a78.83 78.83 0 01-56.55-24.1A80.89 80.89 0 01176 239V128a79.69 79.69 0 0180-80c44.86 0 80 35.14 80 80v111c0 44.66-35.89 81-80 81z\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "class": "ionicon",
    "viewBox": "0 0 512 512"
  }
};